const getYear = () => new Date().getFullYear()

const Copyright = () => {
    return <div
        className="copyright"
    >
        TemplateRoller. All rights reserved. {getYear()} &copy;
    </div>
}

export default Copyright